module.exports = __webpack_public_path__ + "img/max-logo.18a30c2e.svg";